export default {
	default: [''],
	defaultBg1: ['tabs--bg-1'],
	defaultBg2: ['tabs--bg-2'],
	verticalBg0: ['tabs--vertical'],
	verticalBg1: ['tabs--vertical', 'tabs--bg-1'],
	verticalBg2: ['tabs--vertical', 'tabs--bg-2'],
	highlight1: ['tabs--highlight-1']
};
